import { ISetRegionIdParameters } from 'shared/common/repositories/header-frontend/v3/get-header-microfrontend/microfrontend/api/v1/set-region-id/types';

import { apiCall } from '../apiCall';

const MICROFRONTEND_NAME = 'header-frontend';

export const getHeaderMicrofrontendApi = () => {
  return {
    setRegionId: (parameters: ISetRegionIdParameters) => {
      return apiCall(MICROFRONTEND_NAME, '/v1/set-region-id', parameters);
    },
  };
};
